<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Instructor</li>
            </ul>
            <h2>Instructor</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Instructor Details Area -->
<section class="instructor-details-area pt-100 pb-70">
    <app-small-spinner [show]="showSpinner"></app-small-spinner>
    <div class="container">
        <div class="instructor-details-desc">
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <div class="instructor-details-sidebar">
                        <img *ngIf="teacher.image else elseBlock" src="{{teacher.image.fileUrl}}">
                        <ng-template #elseBlock>
                            <img src="assets/img/teacher-placeholder.png">
                        </ng-template>
                    </div>
                </div>

                <div class="col-lg-8 col-md-8">
                    <div class="instructor-details">
                        <h3>{{teacher.nameEn}}</h3>
                        <span class="sub-title">{{teacher.position}}</span>
                        {{teacher.about}}
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="section-title text-left">
            <h2>Courses by Jonkin Jullinor</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-courses-box mb-30">
                    <div class="courses-image">
                        <a href="single-courses.html" class="d-block"><img src="assets/img/courses/1.jpg"
                                alt="image"></a>

                        <div class="courses-tag">
                            <a href="#" class="d-block">Business</a>
                        </div>
                    </div>

                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                            <img src="assets/img/user1.jpg" class="rounded-circle mr-2" alt="image">
                            <span>Steven Smith</span>
                        </div>

                        <h3><a href="single-courses.html" class="d-inline-block">Raque Professional IT Expert
                                Certificate Course</a></h3>

                        <div class="courses-rating">
                            <div class="review-stars-rated">
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                            </div>

                            <div class="rating-total">
                                5.0 (1 rating)
                            </div>
                        </div>
                    </div>

                    <div class="courses-box-footer">
                        <ul>
                            <li class="students-number">
                                <i class='bx bx-user'></i> 10 students
                            </li>

                            <li class="courses-lesson">
                                <i class='bx bx-book-open'></i> 6 lessons
                            </li>

                            <li class="courses-price">
                                Free
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</section>
<!-- End Instructor Details Area -->